(ns dashboard.entity.analysis.state-evidence
  (:require ["react" :as react]
            [dashboard.entity.analysis.document-picker :as document-picker]
            [dashboard.entity.analysis.profile :as analysis.profile]
            [dashboard.entity.evidence.fields :as evidence.fields]
            [dashboard.entity.organization.db :as org.db]
            [dashboard.services.documents :as documents]
            [re-frame.core :as rf]))

(defn Document
  [{:keys [mode state-evidence set-field]}]
  (assert (fn? set-field))
  [analysis.profile/subfield
   "Document"
   [:f> document-picker/document-picker
    (:document-id state-evidence)
    @(rf/subscribe [::documents/loading])
    @(rf/subscribe [::documents/data :filename :asc])
    #(set-field :document-id %)
    (and (= :edit mode)
         (not (:content state-evidence)))]])

(defn StateEvidence
  [{:keys [references
           idx
           state-evidence
           validation-error
           mode
           on-remove-source
           set-field]
    :as props}]

  (assert (int? idx))
  (assert (keyword? mode))
  (assert references)
  (assert (fn? on-remove-source))
  (assert (map? state-evidence))
  (assert (or validation-error (contains? (-> props keys set) :validation-error)))

  (let [[reference-completions set-reference-completions] (react/useState [])
        [selected-completion-index set-selected-completion-index] (react/useState nil)
        option-idx->element-atom (atom {})
        [dropdown-content-ref set-dropdown-content-ref] (react/useState [])
        organization-members @(org.db/organization-members*)
        ;; Wraps the event handler with the evidence index
        props (assoc props :set-field (fn [k value]
                                        (set-field [idx k] value)))]
    [:div.p-4.mb-3.analysis-list-subsection
     [evidence.fields/Header idx mode on-remove-source (:is-valid state-evidence)]
     [:div.level.columns.is-align-items-flex-start.my-0
      [:div.is-half.column.is-align-items-flex-start.my-0
       ;; Editing control-status OR comment should NOT create a new evidence
       ;; otherwise evidence-props is used in order to blow away the evidence
       ;; ID for the edited evidence
       [evidence.fields/ControlStatus props]
       [evidence.fields/Information props]
       [evidence.fields/Provider props]
       [evidence.fields/ValidatedByAutomation props]
       [:f> evidence.fields/Comment props]]
      [:div.is-half.column
       [Document props]
       [evidence.fields/Reference
        props
        reference-completions
        set-reference-completions
        selected-completion-index
        set-selected-completion-index
        option-idx->element-atom
        dropdown-content-ref
        set-dropdown-content-ref]

       (some->> props
                :state-evidence
                :content
                (into [:blockquote])
                vector
                (into [:div.is-size-7.content]))

       [evidence.fields/Expiration props]
       [evidence.fields/Responsibility props organization-members]]]]))

(defn StateEvidences
  [{:keys [sources
           references
           on-new-source
           on-remove-source
           set-field
           validation-errors
           mode]}]
  (let [dummy (react/useState nil)]
   [analysis.profile/field
   (str "Validation Information Sources (" (count sources) ")")
   (when-not (seq sources) "<< No Information Soucrces Specified >>")
   (when (fn? set-field)
     (doall
      (for [[idx source] (map-indexed vector sources)]
        ^{:key (str "source-" idx)}
        [:f> StateEvidence
         {:references references
          :idx idx
          :state-evidence source
          :validation-error (get-in validation-errors [idx])
          :mode mode
          :on-remove-source on-remove-source
          :set-field set-field
          :form-errors @(org.db/form-errors*)
          :save-person (fn [person callback prevent-navigate-on-save]
                         (org.db/save-person
                          person
                          callback
                          prevent-navigate-on-save))
          :organization-view org.db/view-id-organization}])))
   (when (= :edit mode)
     [:div.level
      [:div.level-right]
      [:button.button.is-primary.is-rounded.mt-2
       {:title "Add information source to validate the analysis state"
        :on-click (fn [_]
                    (on-new-source))}
       (if (seq sources)
         "Add another information source"
         "Add information source")]])]))

